import PhotoAlbumUpload from '../Containers/BusinessDirectory/Photos/Components/photoAlbumUpload';

const routes = {
  login: '/login',
  register: '/register',
  otp: '/otp',
  verified: '/otpverification',
  otpverification: '/otpverification',
  emailverification: '/emailverification',
  signup: '/signup',
  onboarding: '/onBoarding',
  forgotPassword: '/forgotPassword',
  changePassword: '/changePassword',
  // home: '/home',
  // myFeed: '/my Feed',
  // myProfile: '/my Profile',
  // careerDetails: '/my Profile/career-details',
  // events: '/events',
  // jobs: '/jobs',

  // jobsViewAll: '/jobs/view-all-jobs',
  // jobDetails: '/jobs',
  // postJob: '/jobs/post-job',
  // appliedJobs: '/jobs/appliedJobs',
  // savedJobs: '/jobs/savedJobs',
  // myJobs: '/jobs/myJobs',
  // resumeLibrary: '/jobs/Resume-library',
  // resumeBuilder: '/jobs/Resume-builder',
  // mentorship: '/mentorship',

  // viewallMentorship: '/mentorship/view-all-mentorship',
  // setupPreference: '/mentorship/Set-up-your-preferences',
  // mentorDetails: '/mentorship/Mentee-Details',
  // fundraise: '/fundraise',
  // fundraiseDetails: '/fundraise',
  // myFunds: '/fundraise/allFunds',
  // activeCampaigns: '/fundraise/Active Campaigns',
  // groups: '/groups',
  // discoverGroups: '/groups/discover-groups',
  // yourGroupsDetails: '/groups/your-groups',
  // CreatedGroupsDetails: 'groups/created-groups',
  // yourGroups: '/groups/Your-groups',
  // createGroup: '/groups/create-group',
  // network: '/network',
  // viewallNetwork: '/network/view-all-network',
  // networkDetails: '/network',
  // mentorshipDetailview: '/mentorship',
  // survey: '/survey',
  // yoursurvey: '/survey/yoursurvey',
  // createSurvey: '/survey/create-survey',
  // test: '/test',
  // service: '/service & support',
  // serviceFAQ: '/service & support/FAQ',
  // RequestService: '/service & support/RequestService',
  // Answers: '/service & support/RequestService',
  // TicketPreview: '/service & support/Ticket-Preview',
  // settings: '/settings',
  // schedule: '/calendar',
  // chats: '/chats',
  // chatsdetails: '/chats/:id',
  // socialLinks: '/socialLinks',
  // privacyPolicy: '/privacy-policy',
  // signupRequest: '/flame-signup',
  // photos: '/photos',
  // PhotoAlbumUpload: '/PhotoAlbumUpload',
  // AlbumViewer: '/album/:folderId',
  // businessdirectory: '/business directory',
  // BusinessDetail: '/business directory/:id',
  // resources: '/resources',
  // createbusinessdirectory: '/business directory/create',
  // allBusinesses: '/business directory/all-businesses',
  // myBusinesses: '/business directory/my-businesses',

  home: '',
  myFeed: '',
  myProfile: '',
  careerDetails: '',
  events: '',
  jobs: '',

  jobsViewAll: '',
  jobDetails: '',
  postJob: '',
  appliedJobs: '',
  savedJobs: '',
  myJobs: '',
  resumeLibrary: '',
  resumeBuilder: '',
  mentorship: '',

  viewallMentorship: '',
  setupPreference: '',
  mentorDetails: '',
  fundraise: '',
  fundraiseDetails: '',
  myFunds: '',
  activeCampaigns: '',
  groups: '',
  discoverGroups: '',
  yourGroupsDetails: '',
  CreatedGroupsDetails: '',
  yourGroups: '',
  createGroup: '',
  network: '',
  viewallNetwork: '',
  networkDetails: '',
  mentorshipDetailview: '',
  survey: '',
  yoursurvey: '',
  createSurvey: '',
  test: '',
  service: '',
  serviceFAQ: '',
  RequestService: '',
  Answers: '',
  TicketPreview: '',
  settings: '',
  schedule: '',
  chats: '',
  chatsdetails: '',
  socialLinks: '',
  privacyPolicy: '',
  signupRequest: '',
  photos: '',
  PhotoAlbumUpload: '',
  AlbumViewer: '',
  businessdirectory: '',
  BusinessDetail: '',
  resources: '',
  createbusinessdirectory: '',
  allBusinesses: '',
  myBusinesses: '',

  // placement portal

  placements: '/placements',
  jobdata: '/placements/jobDetails',
  interviewPrep: '/placements/interviewPrep',
  resumebuilder: '/placements/resumeBuilder',
  resumeeditor: '/placements/resumeEditor',
  createcoverletter: '/placements/coverLetter',
  careercompass: '/placements/careerCompass',
  viewAllJobs: '/placements/viewAll',
  yourapplications: '/placements/yourApplications',
  results: '/placements/results',
  ViewSavedJobs: '/placements/savedJobs',
};

export default routes;
